import { axiosInstance, headersForJwtWithFormdata} from "../config/axiosConfig/axiosConfig";
export const changePassword = async (formData) => {
    try {
      const response = await axiosInstance.post('/v1/sysadmin_dashboard/changePassword', formData, {headers: headersForJwtWithFormdata()});
      return response.data;
    } catch (error) {
      console.error('There was an error!', error);
      throw error;
    }
  };